<template>
    <div class="udp-container">
        <inner-children-renderer v-if="_child" :children="_child" />
    </div>
</template>

<script>
import Vue from 'vue';

const {
    plugins: { ComplexComp },
    store: { variable }
} = require('@futuweb/fego-render');

import ChildItem from '../children/item/render/index.vue';
import { CHILD } from '../constant';
import request from '../assets/scripts/request';

export default Vue.extend({
    name: 'udp-container',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],

    props: ['tpl', 'encode'],

    data() {
        return {
            activeIdx: this.tpl.props.defaultActive
        };
    },

    computed: {
        _child() {
            if (this.activeIdx === -1) {
                return null;
            }

            return this.tpl.children[this.activeIdx];
        }
    },

    async mounted() {
        if (!variable.data.UID) {
            return;
        }
        const isTarget = await this.isTargetUser();
        this.activeIdx = isTarget ? 0 : 1;
    },

    methods: {
        async isTargetUser() {
            try {
                const commonApiRequest = request.bindCommonApi('udp-container');
                const { isTarget } = await commonApiRequest.get('isTargetUser', {
                    encodeContent: this.encode
                });

                return isTarget;
            } catch (err) {
                return false;
            }
        }
    }
});
</script>

<style lang="less" scoped>
.udp-container {
    height: 100% !important;
}
</style>
